import { expenseColNm } from "constants/expenseConstant"
import { billingNoteColNm } from "constants/billingNoteConstant";
import { invoiceColNm } from "constants/invoiceConstant";
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import dayjs from "dayjs";
import { numberFormat } from "utils";
import { GridActionsCellItem } from "@mui/x-data-grid";
import { Button } from "@mui/material";
import { shipmentColNm } from "constants/shipmentConstant";
import { jobColNm } from "constants/jobConstant";
import { jobOrderColNm } from "constants/jobOrderConstant";
export const columns= (handleSendDocDteClick) => [
  {
    field: 'No',
    headerName: 'ลำดับ',
    width: 70,
    align: 'center',
  },
  {
    field: 'CusSNm',
    headerName: billingNoteColNm.CusSNm,
    width: 250,
  },
  {
    field: 'BNDte',
    headerName: billingNoteColNm.BNDte,
    width: 110,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM/YYYY"): "-",
  },
  {
    field: 'RecvPayDte',
    headerName: billingNoteColNm.RecvPayDte,
    width: 110,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM/YYYY"): "-",
  },
  {
    field: 'BNNo',
    headerName: billingNoteColNm.BNNo,
    width: 150,
  },
  {
    field: 'NumInv',
    headerName: "จำนวนใบแจ้งหนี้",
    width: 110,
    align: "center"
  },
  {
    field: 'OwnRcptAmnt',
    headerName: billingNoteColNm.OwnRcptAmnt,
    width: 110,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'CusRcptAmnt',
    headerName: billingNoteColNm.CusRcptAmnt,
    width: 110,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'Total',
    headerName: billingNoteColNm.Total,
    width: 110,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: 'SndDocDte',
    headerName: "วันที่ส่งเอกสาร",
    width: 120,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM/YYYY"): "-",
    renderCell: (params) => {
      return (
        <Button fullWidth sx={{ height: 30 }} variant={params.value ? "contained" : "outlined"} onClick={()=>handleSendDocDteClick(params.row)}>
          {params.value&&dayjs(params.value).format("DD/MM/YYYY")}
        </Button>
      )
    },
  },
  {
    field: 'Rmk',
    headerName: billingNoteColNm.Rmk,
    flex: 1,
  }
]



export const invColumns = (handleDeleteRow)=>[
  
  {
    field: 'InvDte',
    headerName: invoiceColNm.InvDte,
    width: 110,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM/YYYY"): "-",
  },
  {
    field: 'ETD',
    headerName: shipmentColNm.ETD,
    width: 110,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM/YYYY"): "-",
  },
  {
    field: 'ETA',
    headerName: shipmentColNm.ETA,
    width: 110,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM/YYYY"): "-",
  },
  {
    field: 'InvNo',
    headerName: invoiceColNm.InvNo,
    width: 120,
  },
  {
    field: 'JobNos',
    headerName: invoiceColNm.JobNo,
    width: 150,
  },
  {
    field: 'RefNo',
    headerName: invoiceColNm.RefNo,
    width: 100,
  },
  {
    field: 'CmdyTyp',
    headerName: jobColNm.CmdyTyp,
    width: 100,
  },
  {
    field: 'Loc',
    headerName: jobOrderColNm.Loc,
    width: 100,
  },
  {
    field: 'Brnd',
    headerName: "Brand/Vessel",
    valueGetter: ({value, row}) => value || row.Vssl,
    width: 100,
  },
  {
    field: 'LicNm',
    headerName: jobOrderColNm.LicNm,
    width: 100,
  },
  {
    field: 'TlrLicNm',
    headerName: jobOrderColNm.TlrLicNm,
    width: 100,
  },
  {
    field: 'Port',
    headerName: jobOrderColNm.Port,
    width: 100,
  },
  {
    field: 'ContNo',
    headerName: jobOrderColNm.ContNo,
    width: 110,
  },
   {
    field: "TotalTrans",
    headerName: "Transport",
    width: 100,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: "TotalCharge",
    headerName: "Charge",
    width: 100,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: "TotalAdv",
    headerName: "Advance",
    width: 100,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: "GrandTotal",
    headerName: "Total",
    width: 100,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: "WhtPr1Total",
    headerName: "WHT1%",
    width: 100,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: "WhtPr3Total",
    headerName: "WHT3%",
    width: 100,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  {
    field: "PayAmnt",
    headerName: "Pay Amnt",
    width: 100,
    align: "right",
    valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  },
  // {
  //   field: 'OwnRcptAmnt',
  //   headerName: invoiceColNm.OwnRcptAmnt,
  //   width: 100,
  //   align: "right",
  //   valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  // },
  // {
  //   field: 'CusRcptAmnt',
  //   headerName: invoiceColNm.CusRcptAmnt,
  //   width: 100,
  //   align: "right",
  //   valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  // },
  // {
  //   field: 'Total',
  //   headerName: invoiceColNm.Total,
  //   width: 100,
  //   align: "right",
  //   valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  // },
  // {
  //   field: 'OwnRcptAmnt365',
  //   headerName: invoiceColNm.OwnRcptAmnt + " (365)",
  //   width: 110,
  //   align: "right",
  //   valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  // },
  // {
  //   field: 'CusRcptAmnt365',
  //   headerName: invoiceColNm.CusRcptAmnt + " (365)",
  //   width: 110,
  //   align: "right",
  //   valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  // },
  // {
  //   field: 'Total365',
  //   headerName: invoiceColNm.Total + " (365)",
  //   width: 110,
  //   align: "right",
  //   valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  // },
  // {
  //   field: 'GrandTotal',
  //   headerName: "รวมยอด",
  //   width: 110,
  //   align: "right",
  //   valueFormatter: (params)=> params.value? numberFormat(+params.value): "0.00",
  // },
  {
    field: 'Rmk',
    headerName: expenseColNm.Rmk,
    flex: 1,
  },
  {
    hide: !handleDeleteRow,
    field: "actions",
    type: "actions",
    width: 30,
    getActions: (params) => [
      <GridActionsCellItem
        icon={<RemoveCircleIcon />}
        label="Delete"
        onClick={() => handleDeleteRow(params.row)}
      />
    ] ,
  }
]

export const searchInvColumns = (selectInvoice)=>[
  {
    field: 'InvDte',
    headerName: invoiceColNm.InvDte,
    width: 110,
    type: "dateTime",
    valueGetter: (params) => params.value && dayjs(params.value),
    valueFormatter: (params)=> params.value? params.value.format("DD/MM/YYYY"): "-",
  },
  {
    field: 'InvNo',
    headerName: invoiceColNm.InvNo,
    width: 120,
  },
  {
    field: 'JobNos',
    headerName: invoiceColNm.JobNo,
    flex: 1,
  },
  {
    field: 'ShpmTypNms',
    headerName: "ประเภทงาน",
    width: 100,
  },
  {
    field: "actions",
    type: "actions",
    width: 30,
    getActions: (params) => [
      <GridActionsCellItem
        icon={<ArrowForwardRoundedIcon />}
        label="เลือก"
        onClick={(e) =>{  
          e.stopPropagation()
          selectInvoice(params.row)}
        }
      />
    ] ,
  }
]
/**
 * 
 * Column Defination
 * {
 *   ...Datagrid Column
 *   printWidth: number
 *   printType: "number" | "string" //default string
 *   printAlign: "left" | "center" | "right" //default left
 *   printMaxLength: number //default 13/1 char/inch
 *   printNullChar: string //default "-"
 * }
 */
export const printBNColumns = [
  {
    field: "No",
    headerName: "No.",
    printWidth: 0.2,
    printAlign: "center",
    align: 'center',
    printNullChar: "",
  },
  {
    field: "ETD",
    headerName: "ETD",
    printWidth: 0.6,
    printAlign: "center",
    printType: "datetime",
    printFormat: "DD/MM/YYYY",
    printNullChar: "",
  },
  {
    field: "ETA",
    headerName: "ETA",
    printWidth: 0.6,
    printAlign: "center",
    printType: "datetime",
    printFormat: "DD/MM/YYYY",
    printNullChar: "",
  },
  {
    field: "InvNo",
    headerName: "Inv No.",
    printWidth: 0.7,
    printMaxLength: 99,
  },
  {
    field: "CusInv",
    headerName: "Cus.Inv.No.",
    printWidth: 0.6,
    printMaxLength: 99,
  },
  // {
  //   field: "ShRef1",
  //   headerName: "Ref No.",
  //   printWidth: 0.7,
  //   printAlign: "center",
  //   align: 'center',
  // },
  {
    field: "CmdyTyp",
    headerName: "Goods",
    printWidth: 0.7,
    printMaxLength: 16,
  },
  {
    field: "Loc",
    headerName: "Loading Location",
    printWidth: 1.0,
    printMaxLength: 28,
  },
  {
    field: "Brnd",
    headerName: "Brand",
    printWidth: 0.7,
    printMaxLength: 99,
  },
  // {
  //   field: "DrvNm",
  //   headerName: "Driver",
  //   printWidth: 0.75,
  // },
  {
    field: "LicNm",
    headerName: "Truck",
    printWidth: 0.6,
    printAlign: "center",
  },
  {
    field: "TlrLicNm",
    headerName: "Trailer",
    printWidth: 0.6,
    printAlign: "center",
  },
  {
    field: "Port",
    headerName: "Port",
    printWidth: 0.7,
    printMaxLength: 12,
  },
  {
    field: "ContNo",
    headerName: "Container No.",
    printWidth: 0.7,
    printMaxLength: 99,
  },
  {
    field: "TotalTrans",
    headerName: "Transport",
    printType: "number",
    printAlign: "right",
    printMaxLength: 99,
    printWidth: 0.5,
    printNullChar: "",
  },
  {
    field: "TotalCharge",
    headerName: "Charge",
    printType: "number",
    printAlign: "right",
    printMaxLength: 99,
    printWidth: 0.5,
    printNullChar: "",
  },
  {
    field: "TotalAdv",
    headerName: "Advance",
    printType: "number",
    printAlign: "right",
    printMaxLength: 99,
    printWidth: 0.5,
    printNullChar: "",
  },
  {
    field: "GrandTotal",
    headerName: "Total",
    printType: "number",
    printAlign: "right",
    printMaxLength: 99,
    printWidth: 0.5,
    printNullChar: "",
  },
  {
    field: "WhtPr1Total",
    headerName: "WHT1%",
    printType: "number",
    printAlign: "right",
    printMaxLength: 99,
    printWidth: 0.45,
    printNullChar: "",
  },
  {
    field: "WhtPr3Total",
    headerName: "WHT3%",
    printType: "number",
    printAlign: "right",
    printMaxLength: 99,
    printWidth: 0.45,
    printNullChar: "",
  },
  {
    field: "PayAmnt",
    headerName: "Pay Amnt",
    printType: "number",
    printAlign: "right",
    printMaxLength: 99,
    printWidth: 0.6,
    printNullChar: "",
  },
]

export const lang = {
  No: {EN: "No.", CN: "序号"},
  CmdyTyp: {EN: "Goods", CN: "Goods/货物"},
  Loc: {EN: "Loading Location", CN: "Description/工厂地址"},
  Brnd: {EN: "Brand", CN: "Brand/品牌"},
  DrvNm: {EN: "Driver", CN: "Driver/司机"},
  LicNm: {EN: "Truck", CN: "Truck/车牌"},
  Port: {EN: "Port", CN: "Port/关口"},
  ContNo: {EN: "Container No.", CN: "柜号"},
  TotalTrans: {EN: "Transport", CN: "Transport/运费"},
  TotalCharge: {EN: "Charge", CN: "Charge"},
  TotalAdv: {EN: "Advance", CN: "Advance"},
  GrandTotal: {EN: "Total", CN: "Total"},
  WhtPr1Total: {EN: "WHT 1%", CN: "WHT 1%"},
  WhtPr3Total: {EN: "WHT 3%", CN: "WHT 3%"},
  PayAmnt: {EN: "Pay Amnt", CN: "Pay Amnt/应收"},
  ETD: {EN: "ETD", CN: "ETD"},
  ETA: {EN: "ETA", CN: "ETA"},
  CusInv: {EN: "Cus.Inv.No.", CN: "Cus.Inv.No."},
  Bank: {EN: "Bank", CN: "Bank"}
}


// export const printBNColumnsChinese = [
//   {
//     field: "No",
//     headerName: "序号",
//     printWidth: 0.2,
//     printAlign: "center",
//     align: 'center',
//   },
//   {
//     field: "ETD",
//     headerName: "ETD",
//     printWidth: 0.55,
//     printAlign: "center",
//     printType: "datetime",
//     printFormat: "DD/MM/YYYY",
//   },
//   {
//     field: "ETA",
//     headerName: "ETA",
//     printWidth: 0.55,
//     printAlign: "center",
//     printType: "datetime",
//     printFormat: "DD/MM/YYYY",
//   },
//   {
//     field: "CusInv",
//     headerName: "Cus.Inv.No.",
//     printWidth: 0.55,
//     printAlign: "center",
//     align: 'center',
//   },
//   {
//     field: "CmdyTyp",
//     headerName: "Goods/货物",
//     printWidth: 0.55,
//   },
//   {
//     field: "Loc",
//     headerName: "Description/工厂地址",
//     printWidth: 1,
//     printMaxLength: 20,
//   },
//   {
//     field: "Brnd",
//     headerName: "Brand/品牌",
//     printWidth: 0.55,
//   },
//   {
//     field: "DrvNm",
//     headerName: "Driver/司机",
//     printWidth: 0.75,
//   },
//   {
//     field: "LicNm",
//     headerName: "Truck/车牌",
//     printWidth: 0.5,
//   },
//   {
//     field: "Port",
//     headerName: "Port/关口",
//     printWidth: 0.65,
//     printMaxLength: 12,
//   },
//   {
//     field: "ContNo",
//     headerName: "柜号",
//     printWidth: 0.55,
//   },
//   {
//     field: "TotalTrans",
//     headerName: "Transport/运费",
//     printType: "number",
//     printAlign: "right",
//     printWidth: 0.55,
//   },
//   {
//     field: "TotalCharge",
//     headerName: "Charge",
//     printType: "number",
//     printAlign: "right",
//     printWidth: 0.55,
//   },
//   {
//     field: "TotalAdv",
//     headerName: "Advance",
//     printType: "number",
//     printAlign: "right",
//     printWidth: 0.55,
//   },
//   {
//     field: "GrandTotal",
//     headerName: "Total",
//     printType: "number",
//     printAlign: "right",
//     printWidth: 0.55,
//   },
//   {
//     field: "WhtPr1Total",
//     headerName: "WHT 1%",
//     printType: "number",
//     printAlign: "right",
//     printWidth: 0.4,
//   },
//   {
//     field: "WhtPr3Total",
//     headerName: "WHT 3%",
//     printType: "number",
//     printAlign: "right",
//     printWidth: 0.4,
//   },
//   {
//     field: "PayAmnt",
//     headerName: "Pay Amnt/应收",
//     printType: "number",
//     printAlign: "right",
//     printWidth: 0.6,
//   },
// ]

export const printBankAccount = [
  {
    field: "Bank",
    headerName: "Bank",
    printWidth: 2,
    printMaxLength: 99,
  },
  {
    field: "AccNo",
    headerName: "Account No.",
    printWidth: 2,
    printMaxLength: 99,
  },
  {
    field: "AccNm",
    headerName: "Account Name",
    printWidth: 2,
    printMaxLength: 99,
  },
  {
    field: "Amnt",
    headerName: "Pay Amnt",
    printWidth: 1.5,
    printType: "number",
    printAlign: "right",
  }
]
